<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title">Animal totem<br/>7</h1>
<h2 class="title"><strong>L’Arbre Éternel</strong></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// htp.vue?477f339f